import { render } from "./CommentsView.vue?vue&type=template&id=44342457&scoped=true"
import script from "./CommentsView.vue?vue&type=script&lang=js"
export * from "./CommentsView.vue?vue&type=script&lang=js"

import "./CommentsView.vue?vue&type=style&index=0&id=44342457&scoped=true&lang=css"

import exportComponent from "C:\\Users\\kobayashi.y\\develop\\thxily_fastapi\\vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-44342457"]])

export default __exports__